"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContractDetail = void 0;
const base_model_1 = require("../../base-model");
const event_contract_detail_schema_1 = require("./event-contract-detail.schema");
class EventContractDetail extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return event_contract_detail_schema_1.eventContractDetailSchema;
    }
}
exports.EventContractDetail = EventContractDetail;
